<template>
    <v-dialog
            max-width="300"
            v-model="isOpen"
            @close="close"
    >
        <v-card min-height="200">
            <div class="spacer"></div>
            <v-card-title class="text-center">
                Недостаточно прав для <br>  доступа к разделу.
            </v-card-title>
            <div class="spacer"></div>
            <v-card-text class="text-center">
                <v-btn text color="orange" @click="close">Закрыть</v-btn>
            </v-card-text>
        </v-card>
        <v-card></v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "AccessDenied",
        props: ['open'],
        computed: {
            isOpen: {
                get() {
                    return this.open;
                },
                set(newValue) {
                    if(!newValue)
                        this.close();
                }
            }
        },
        methods: {
            close() {
                const data = this.$store.getters.access;
                data.showModal = false;

                this.$store.commit('setAccess', data);
            }
        }
    }
</script>

<style scoped>

</style>